import React, { useState } from 'react';
import { Layout } from '../Layout';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import Input from '@cloudscape-design/components/input';
import FormField from '@cloudscape-design/components/form-field';
import Button from '@cloudscape-design/components/button';
import Form from '@cloudscape-design/components/form';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { getApiHeader } from 'src/utils';
import { Participants } from './Participants';
import Select from '@cloudscape-design/components/select';
import { OptionDefinition } from '@cloudscape-design/components/internal/components/option/interfaces';
import { gradesList } from 'src/utils/constant';

export const CheckIn: React.FC = () => {
    const headers = getApiHeader();

    const [chestNumber, setChestNumber] = useState<string>("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [firstName, setFirstName] = useState("");
    const [selectedGrade, setSelectedGrade] = useState<OptionDefinition>({ label: 'Select grade', value: '' });

    const { mutate, data, error, isSuccess, isPending, reset: resetData } = useMutation({
        mutationFn: (data: { firstName?: string, chestNumber?: string, phoneNumber?: string, grade?: string }) => {
            return axios.post('https://3ioff575bb.execute-api.us-east-1.amazonaws.com/Prod/searchParticipants',
                data, {
                headers
            });
        },
    });

    const reset = () => {
        setChestNumber("");
        setPhoneNumber("");
        setFirstName("");
        setSelectedGrade({ label: 'Select grade', value: '' });
        resetData();
    }

    const searchParticipant = () => {
        mutate({ chestNumber, firstName, phoneNumber, grade: selectedGrade.value });
    }

    return (
        <Layout breadcrumbs={[
            {
                href: '/checkin',
                text: 'Check-in'
            }
        ]}>
            <SpaceBetween direction="vertical" size="m">
                <ExpandableSection
                    defaultExpanded
                    variant="container"
                    headerText="Search Participant"
                >
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">
                                <Button onClick={reset} formAction="none" variant="link">
                                    Clear
                                </Button>
                                <Button variant="primary" loading={isPending} onClick={searchParticipant}>Search</Button>
                            </SpaceBetween>
                        }
                    >
                        <SpaceBetween direction="horizontal" size="l">
                            <FormField label="Chest number">
                                <Input value={chestNumber} onChange={({ detail }) => setChestNumber(detail.value)} placeholder='Chest number' />
                            </FormField>
                            <FormField label="Phone number">
                                <Input value={phoneNumber} onChange={({ detail }) => setPhoneNumber(detail.value)} placeholder='Phone number' />
                            </FormField>
                            <FormField label="First name">
                                <Input value={firstName} onChange={({ detail }) => setFirstName(detail.value)} placeholder='First name' />
                            </FormField>
                            <FormField label="Grade">
                                <Select
                                    selectedOption={selectedGrade}
                                    onChange={({ detail }) => {
                                        setSelectedGrade(detail.selectedOption);
                                    }
                                    }
                                    options={gradesList.map((grade) => ({
                                        label: grade, value: grade
                                    }))} />
                            </FormField>
                        </SpaceBetween>
                    </Form>
                </ExpandableSection>
                {
                    data?.data && (<Participants participants={data?.data.result} />)
                }
            </SpaceBetween>
        </Layout>
    );
}